
import { Controller } from 'stimulus'
import * as h from 'lib/helpers'

export default class ReportExport_ProcessCheckController extends Controller {
  static targets = ['container', 'doneTemplate']

  click(event) {
    event.preventDefault()

    h.openLocation($(event.target).attr('href'))
  }

  connect() {
    this._reportExportProcessCheckChannel = SecuricyApp.cable.subscriptions.create({
      channel: 'ReportExport::ProcessCheckChannel',
      export_ticket: this.exportTicket
    }, {
      received: (data) => this.handleCheck(data)
    })

    this._pollInterval = setInterval(() => this.poll(), 5000)
  }

  poll() {
    this._reportExportProcessCheckChannel.perform('check')
  }

  handleCheck(data) {
    if (data) {
      this.containerTarget.innerHTML = h.renderTemplate(this._doneTemplate, data.generated_report)

      this.disconnect()
    }
  }

  disconnect() {
    clearTimeout(this._pollInterval)

    this._reportExportProcessCheckChannel.unsubscribe()
  }

  get exportTicket() {
    return this.data.get('exportTicket')
  }

  get _doneTemplate() {
    return this.doneTemplateTarget.innerHTML
  }
}
